<template>
  <div class="jyjl-container">
    <div class="transaction-section">
      <!-- 筛选栏 -->
      <!-- <div class="jyjl-filter-bar">
        <div class="jyjl-filter-group"> -->
      <!-- <div class="jyjl-filter-item">
            <label class="jyjl-filter-label">{{ $t('_txjl._ztsx') }}</label>
            <select v-model="filters.status" class="jyjl-filter-select">
              <option value="all">{{ $t('_txjl._qbzt') }}</option>
              <option value="pending">{{ $t('_txjl._shz') }}</option>
              <option value="approved">{{ $t('_txjl._ytg') }}</option>
              <option value="rejected">{{ $t('_txjl._yjj') }}</option>
            </select>
          </div> -->

      <!-- <div class="jyjl-filter-item">
                        <label class="jyjl-filter-label">时间范围</label>
                        <select v-model="filters.dateRange" class="jyjl-filter-select">
                            <option value="all">全部时间</option>
                            <option value="today">今天</option>
                            <option value="week">本周</option>
                            <option value="month">本月</option>
                        </select>
                    </div>

                    <div class="jyjl-filter-item">
                        <label class="jyjl-filter-label">金额排序</label>
                        <select v-model="filters.amountSort" class="jyjl-filter-select">
                            <option value="default">默认排序</option>
                            <option value="high">金额从高到低</option>
                            <option value="low">金额从低到高</option>
                        </select>
                    </div> -->
      <!-- </div>

        <div class="jyjl-search-group">
          <div class="jyjl-search-box">
            <i class="fas fa-search"></i>
            <input v-model="filters.search" type="text" :placeholder="$t('_txjl._ssdz')" class="jyjl-search-input" />
            <button v-if="filters.search" class="jyjl-clear-search" @click="filters.search = ''">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div> -->

      <!-- 交易列表 -->
      <div class="jyjl-transaction-list">
        <div class="jyjl-list-header">
          <div class="jyjl-header-cell jyjl-currency" style="width: 10%">{{ $t('_txjl._bz') }}</div>
          <div class="jyjl-header-cell jyjl-amount" style="width: 20%">{{ $t('_txjl._je') }}</div>
          <div class="jyjl-header-cell jyjl-address" style="width: 25%">{{ $t('_txjl._dz') }}</div>
          <div class="jyjl-header-cell jyjl-status" style="width: 15%">{{ $t('_txjl._zt') }}</div>
          <div class="jyjl-header-cell jyjl-time" style="width: 20%">{{ $t('_txjl._sj') }}</div>
          <div class="jyjl-header-cell jyjl-actions" style="width: 10%">{{ $t('_txjl._cz') }}</div>
        </div>

        <div
          v-for="transaction in filteredTransactions"
          :key="transaction.id"
          class="jyjl-transaction-item"
          :class="{
            'jyjl-pending': transaction.status === 'pending',
            'jyjl-approved': transaction.status === 'approved'
          }"
        >
          <div class="jyjl-table-cell jyjl-currency" style="width: 10%">
            <div class="jyjl-currency-info">
              <!-- <div class="jyjl-currency-icon jyjl-usdt">
                                <i class="fas fa-dollar-sign"></i>
                            </div> -->
              <div class="jyjl-currency-details">
                <div class="jyjl-currency-name">{{ transaction.name }}</div>
                <div class="jyjl-currency-network">{{ transaction.network }}</div>
              </div>
            </div>
          </div>

          <div class="jyjl-table-cell jyjl-amount" style="width: 20%">
            <div class="jyjl-amount-display">${{ transaction.real_number }}</div>
          </div>

          <div class="jyjl-table-cell jyjl-address" style="width: 25%">
            <div class="jyjl-address-display">
              <div class="jyjl-address-text" :title="transaction.transfer_token">
                {{ formatAddress(transaction.transfer_token) }}
              </div>
              <div class="jyjl-address-actions">
                <button class="jyjl-action-btn jyjl-copy-btn" @click="copyAddress(transaction.transfer_token)">
                  <CopyOutlined />
                </button>
              </div>
            </div>
          </div>

          <div class="jyjl-table-cell jyjl-status" style="width: 15%">
            <div class="jyjl-status-badge" :class="getStatusClass(transaction.status)">
              {{ getStatusText(transaction.status) }}
            </div>
          </div>

          <div class="jyjl-table-cell jyjl-time" style="width: 20%">
            <div class="jyjl-time-display">
              <div class="jyjl-time-date">{{ formatDate(transaction.create_time) }}</div>
              <div class="jyjl-time-hour">{{ formatTime(transaction.create_time) }}</div>
            </div>
          </div>

          <div class="jyjl-table-cell jyjl-actions" style="width: 10%">
            <div class="jyjl-action-buttons">
              <button class="jyjl-action-btn jyjl-detail-btn" @click="showDetails(transaction)">
                <EyeOutlined />
              </button>
              <!-- <button class="jyjl-action-btn jyjl-cancel-btn" v-if="transaction.status === 1"
                            @click="cancelTransaction(transaction.id)">
                            <i class="fas fa-times"></i>
                        </button> -->
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="filteredTransactions.length === 0" class="jyjl-empty-state">
          <div class="jyjl-empty-icon">
            <i class="fas fa-receipt"></i>
          </div>
          <h3>{{ $t('_txjl._zwjl') }}</h3>
          <!-- <p>当前筛选条件下没有找到交易记录</p> -->
          <button class="jyjl-reset-filter-btn" @click="resetFilters">
            <i class="fas fa-refresh"></i>
            {{ $t('_txjl._czsx') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="jyjl-pagination" v-if="filteredTransactions.length > 0">
      <button class="jyjl-page-btn" :disabled="page === 1" @click="onPage(page - 1)">
        <left-outlined />
      </button>
      <span class="jyjl-page-info">{{ $t('_txjl._dny', { a: page, b: totalPages }) }}</span>
      <button class="jyjl-page-btn" :disabled="page === totalPages" @click="onPage(page + 1)">
        <right-outlined />
      </button>
    </div>

    <!-- 交易详情弹窗 -->
    <div v-if="selectedTransaction" class="jyjl-modal-overlay">
      <div class="jyjl-modal-content">
        <div class="jyjl-modal-header">
          <h3>{{ $t('_txjl._jyxq') }}</h3>
          <button class="jyjl-close-btn" @click="selectedTransaction = null">
            <CloseCircleOutlined style="font-size: 24px" />
          </button>
        </div>
        <div class="jyjl-modal-body">
          <div class="jyjl-detail-item">
            <span class="jyjl-detail-label">{{ $t('_txjl._bz') }}:</span>
            <span class="jyjl-detail-value">{{ selectedTransaction.name }} ({{ selectedTransaction.network }})</span>
          </div>
          <div class="jyjl-detail-item">
            <span class="jyjl-detail-label">{{ $t('_txjl._je') }}:</span>
            <span class="jyjl-detail-value jyjl-amount-value">${{ selectedTransaction.real_number }}</span>
          </div>
          <div class="jyjl-detail-item">
            <span class="jyjl-detail-label">{{ $t('_txjl._skdz') }}:</span>
            <span class="jyjl-detail-value jyjl-address-full">{{ selectedTransaction.transfer_token }}</span>
          </div>
          <div class="jyjl-detail-item">
            <span class="jyjl-detail-label">{{ $t('_txjl._jysj') }}:</span>
            <span class="jyjl-detail-value">{{ formatFullTime(selectedTransaction.create_time) }}</span>
          </div>
          <div class="jyjl-detail-item">
            <span class="jyjl-detail-label">{{ $t('_txjl._jyzt') }}:</span>
            <span class="jyjl-status-badge" :class="getStatusClass(selectedTransaction.status)">
              {{ getStatusText(selectedTransaction.status) }}
            </span>
          </div>
          <!-- <div class="jyjl-detail-item" v-if="selectedTransaction.status === 'pending'">
            <span class="jyjl-detail-label">预计到账:</span>
            <span class="jyjl-detail-value jyjl-expected-time">1-3个工作日内</span>
          </div>
          <div class="jyjl-detail-item" v-if="selectedTransaction.hash">
            <span class="jyjl-detail-label">交易哈希:</span>
            <span class="jyjl-detail-value jyjl-hash-value">{{ selectedTransaction.hash }}</span>
          </div> -->
        </div>
        <!-- <div class="jyjl-modal-footer">
          <button class="jyjl-copy-all-btn" @click="copyTransactionInfo(selectedTransaction)">
            <i class="fas fa-copy"></i>
            复制交易信息
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { CopyOutlined, EyeOutlined, RightOutlined, LeftOutlined, CloseCircleOutlined } from '@ant-design/icons-vue'
export default {
  name: 'TransactionRecords',
  components: { CopyOutlined, EyeOutlined, RightOutlined, LeftOutlined, CloseCircleOutlined },
  data() {
    return {
      selectedTransaction: null,
      filters: {
        status: 'all',
        dateRange: 'all',
        amountSort: 'default',
        search: ''
      },

      STATUS: {
        1: { text: '_cb._shz', class: 'status-review' },
        2: { text: '_cb._yyg', class: 'status-complete' },
        3: { text: '_cb._ybh', class: 'status-reject' }
      },
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      transactions: [
        // {
        //     id: 'TX001',
        //     currency: 'USDT',
        //     network: 'TRC20',
        //     amount: '1',
        //     address: 'TPWZugHaZxh7PoZy6kzm8Vkk2THMQ3KhN5',
        //     status: 'pending',
        //     time: new Date('2025-11-16 04:07:00'),
        //     hash: ''
        // },
      ]
    }
  },
  created() {
    this.getUserTransferList()
  },
  computed: {
    filteredTransactions() {
      let filtered = this.transactions.filter((transaction) => {
        // 状态筛选
        if (this.filters.status !== 'all') {
          if (transaction.status !== this.filters.status) {
            return false
          }
        }

        // 搜索筛选
        if (this.filters.search) {
          const searchLower = this.filters.search.toLowerCase()
          const matchesAddress = transaction.address.toLowerCase().includes(searchLower)
          const matchesAmount = transaction.amount.toLowerCase().includes(searchLower)
          if (!matchesAddress && !matchesAmount) return false
        }

        // 时间范围筛选
        if (this.filters.dateRange !== 'all') {
          const now = new Date()
          const transactionDate = new Date(transaction.time)

          switch (this.filters.dateRange) {
            case 'today':
              return transactionDate.toDateString() === now.toDateString()
            case 'week': {
              const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
              return transactionDate >= weekAgo
            }
            case 'month': {
              const monthAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000)
              return transactionDate >= monthAgo
            }
          }
        }

        return true
      })

      // 金额排序
      if (this.filters.amountSort !== 'default') {
        filtered.sort((a, b) => {
          const amountA = parseFloat(a.amount)
          const amountB = parseFloat(b.amount)
          return this.filters.amountSort === 'high' ? amountB - amountA : amountA - amountB
        })
      } else {
        // 默认按时间倒序
        filtered.sort((a, b) => new Date(b.time) - new Date(a.time))
      }

      // 分页
      // const start = (this.page - 1) * this.pageSize
      // const end = start + this.pageSize
      // return filtered.slice(start, end)
      return filtered
    },
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  methods: {
    onPage(page) {
      this.page = page
      this.getUserTransferList()
    },
    getUserTransferList() {
      let that = this
      var hide = this.$message.loading({ content: 'loading...', key: 'msg' })
      this.$api.userWallet
        .getUserTransferList({
          page: that.page,
          size: that.pageSize,
          search: ''
        })
        .then((res) => {
          hide()
          that.transactions = res.data.data
          that.total = res.data.total
        })
    },
    getStatusClass(status) {
      return `jyjl-status-${status}`
    },
    getStatusText(status) {
      return this.$t(this.STATUS[status].text) || status
    },
    formatAddress(address) {
      if (address.length <= 16) return address
      return address.substring(0, 8) + '...' + address.substring(address.length - 8)
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('zh-CN')
    },
    formatTime(date) {
      return new Date(date).toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    formatFullTime(date) {
      return new Date(date).toLocaleString('zh-CN')
    },
    copyAddress(address) {
      navigator.clipboard.writeText(address).then(() => {
        this.$message.success(this.$t('_txjl._fzdz'))
      })
    },
    //     copyTransactionInfo(transaction) {
    //       const info = `交易ID: ${transaction.id}
    // 币种: ${transaction.currency} (${transaction.network})
    // 金额: $${transaction.amount}
    // 地址: ${transaction.address}
    // 时间: ${this.formatFullTime(transaction.time)}
    // 状态: ${this.getStatusText(transaction.status)}`

    //       navigator.clipboard.writeText(info).then(() => {
    //         this.$message.success('交易信息已复制到剪贴板')
    //       })
    //     },
    showDetails(transaction) {
      this.selectedTransaction = transaction
    },
    // cancelTransaction(id) {
    //   this.$confirm('确定要取消这笔交易吗？', '取消确认', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     const transaction = this.transactions.find((t) => t.id === id)
    //     if (transaction) {
    //       transaction.status = 'rejected'
    //       this.$message.success('交易已取消')
    //     }
    //   })
    // },
    // exportRecords() {
    //   this.$message.success('交易记录导出成功')
    // },
    resetFilters() {
      this.filters = {
        status: 'all',
        dateRange: 'all',
        amountSort: 'default',
        search: ''
      }
      this.page = 1
    }
  }
}
</script>

<style scoped>
@import url('../../static/css_withdrawal/1.css');
</style>
